module.exports = __webpack_public_path__ + "img/3.2d615a95.jpg";